export default function repeatableBookingService(
    $http,
    $q,
    $filter,
    API_LEGACY,
    moment,
    Users
) {
    var service = this;

    const getUserId = () => {
        return Users.isAuthenticated().then(
            (userId) => {
                return $q.resolve(userId);
            },
            () => {
                let userId = 0;
                return $q.resolve(userId);
            }
        );
    };

    /**
     * request availability on a single period
     * @param  {obj}    repeatable [description]
     * @param  {[type]} booking    [description]
     * @return {[type]}            [description]
     */
    service.getAvailableRepeatable = function (weekday, booking) {
        return getUserId().then((userId) => {
            booking.fromTime = encodeURIComponent(
                moment(booking.FromDate).format("HH-mm")
            );
            booking.toTime = encodeURIComponent(
                moment(booking.ToDate).format("HH-mm")
            );

            var url =
                API_LEGACY +
                "/HouseResults/HallParentSearchSpecific/" +
                moment(weekday).format("DD-MM-YYYY") +
                "/" +
                booking.houseCategory.CategoryID +
                "/" +
                booking.LaneID +
                "/" +
                booking.fromTime +
                "/" +
                booking.toTime;

            url += `/${userId}?t=${new Date().getTime()}`; // t=? to prevent caching
            return $http.post(url);
        });
    };

    return service;
}
